import { render, staticRenderFns } from "./QboJobSyncAlert.vue?vue&type=template&id=10c1bf7c"
import script from "./QboJobSyncAlert.vue?vue&type=script&lang=js"
export * from "./QboJobSyncAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports